import Vue from "vue";
import VueRouter from "vue-router";
import VueMeta from "vue-meta";
import PagesManager from "@/views/PagesManager";
import DemandeBourse from "@/views/DemandeBourse";
import ConcoursExtranet from "@/views/ConcoursExtranet";
import ConversationListe from "@/views/ConversationListe";
import ConversationDetails from "@/views/ConversationDetails";
import AnnexesCandidature from "@/views/AnnexesCandidature";
import ListeDb from "@/views/ListeDossierBourse";
import DossierBourse from "@/views/DossierBourse";
import CandidatureBourseFirsi from "@/views/CandidatureBourseFirsi";
import InscripionUni from "@/views/InscriptionUniversite";
import AnnexesInscrUm6p from "@/components/InscriptionUniversite/AnnexesInscrUm6pComponent";
import InscripionExtra from "@/views/InscriptionExtranet";
import DejaInscrit from "@/views/DejaInscrit";
import InscriptionPriseEncompte from "@/views/InscriptionPriseEncompte";
import InscriptionUm6pConfirmee from "@/components/InscriptionUniversite/ConfirmationInscriptionUm6p";
import InscriptionUm6pComplement from "@/components/InscriptionUniversite/ComplementSoumis";
import AnnexesBecr from "@/components/CandidatureBourseFirsi/Annexes";
import NonConnecte from "@/views/NonConnecte";
import ListeCandidatures from "@/views/ListeCandidatureBourse";
import SousMenuUm6p from "@/views/SousMenuUm6p.vue";
import ResultatBac from "@/views/ResultatBac.vue";
import VueTheMask from "vue-the-mask";
import ListeBourses from "../views/ListeBourses.vue";
import FicheBourse from "../views/FicheBourse.vue";
import VerifCniEcoleCentrale from "../views/VerifCniEcoleCentrale.vue";
import DossierBourseEcoleCentrale from "../views/DossierBourseEcoleCentrale.vue";
import AnnexesBourseEcoleCentrale from "@/components/BourseEcoleCentrale/Annexes.vue";

Vue.use(VueRouter);
Vue.use(VueMeta);
Vue.use(VueTheMask);

const routes = [
  { path: "/dossierboursecentrale/:cni", name: "dossierboursecentrale", component: DossierBourseEcoleCentrale },
  { path: "/fichebourse/:id", name: "fichebourse", component: FicheBourse },
  { path: "/CniEcoleCentrale", name: "CniEcoleCentrale", component: VerifCniEcoleCentrale },
  { path: "/listebourses", name: "ListeBourses", component: ListeBourses },
  { path: "/resultatbac", name: "resultatbac", component: ResultatBac },
  { path: "/SousMenuUm6p", name: "SousMenuUm6p", component: SousMenuUm6p },
  { path: "/CandidatureBourseFirsi", name: "CandidatureBourseFirsi", component: CandidatureBourseFirsi },
  { path: "/Bourse", name: "DemandeBourse", component: DemandeBourse },
  { path: "/PagesManager", name: "PagesManager", component: PagesManager },
  { path: "/Concours", name: "ConcoursExtranet", component: ConcoursExtranet },
  { path: "/conversation/liste", name: "MessagerieListe", component: ConversationListe },
  { path: "/conversation/details", name: "ConversationDetails", component: ConversationDetails },
  { path: "/Annexes", name: "AnnexesCandidature", component: AnnexesCandidature },
  { path: "/ListeDb", name: "ListeDb", component: ListeDb },
  { path: "/DossierBourse", name: "DossierBourse", component: DossierBourse },
  { path: "/InscriptionUniversite", name: "InscriptionUniversite", component: InscripionUni },
  { path: "/InscriptionExtranet", name: "InscriptionExtranet", component: InscripionExtra },
  { path: "/DejaInscrit", name: "DejaInscrit", component: DejaInscrit },
  { path: "/InscriptionPriseEncompte", name: "InscriptionPriseEncompte", component: InscriptionPriseEncompte },
  { path: "/AnnexesInscrUm6p", name: "AnnexesInscrUm6p", component: AnnexesInscrUm6p },
  { path: "/AnnexesBecr", name: "AnnexesBecr", component: AnnexesBecr },
  { path: "/InscriptionConfirmee", name: "InscriptionConfirmee", component: InscriptionUm6pConfirmee },
  { path: "/InscriptionComplement", name: "InscriptionComplement", component: InscriptionUm6pComplement },
  { path: "/NonConnecte", name: "NonConnecte", component: NonConnecte },
  { path: "/ListeCb", name: "ListeCandidatures", component: ListeCandidatures },
  { path: "/AnnexeEcoleCentrale", name: "AnnexesBourseEcoleCentrale", component: AnnexesBourseEcoleCentrale },
];

const router = new VueRouter({
  routes,
});

/* ------------------------------------------
   GTM DYNAMIC LOADER (MULTI-CONTAINER)
------------------------------------------- */

function loadGTM(id) {
  // Évite de charger deux fois le même conteneur
  if (!window.loadedGtmIds) window.loadedGtmIds = [];
  if (window.loadedGtmIds.includes(id)) return;

  /* -------- SCRIPT DANS <head> -------- */
  (function(w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    const f = d.getElementsByTagName(s)[0];
    const j = d.createElement(s);
    const dl = l !== 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', id);

  /* -------- NOSCRIPT DANS <body> -------- */
  const noscript = document.createElement('noscript');
  noscript.innerHTML =
    `<iframe src="https://www.googletagmanager.com/ns.html?id=${id}"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
  document.body.insertBefore(noscript, document.body.firstChild);

  window.loadedGtmIds.push(id);
}

/* ------------------------------------------
   LOAD GTM ONLY ON SPECIFIC ROUTES
------------------------------------------- */

const GTM_ABS = "GTM-TQG8KRS"; 
const GTM_SHBM  = "GTM-NCZ94SM";

const pagesWithGTM = [
  "InscriptionExtranet",
  "InscriptionPriseEncompte"
];

router.afterEach((to) => {
  if (pagesWithGTM.includes(to.name)) {
    loadGTM(GTM_ABS);
    loadGTM(GTM_SHBM);
  }
});

export default router;
